import * as React from 'react';
import Helmet from 'react-helmet';
import { Config } from '../../config/index';
import { IArticle } from '../../definitions/news';
import StaticBanner from '../../components/StaticBanner/index';
import './news_article.css';

export default function NewsDetailRender() {
  if (!this.article) {
    return null;
  }

  const {
    title,
    url,
    body,
    meta_description,
    images: {
      banner
    }
  } = this.article;

  return (
    <React.Fragment>
      <Helmet>
        <title>{title}</title>
        <link rel="canonical" href={`${Config.FRONT_END_URL}/news/${url}`} />
        <meta name="description" content={meta_description} />
      </Helmet>

      <StaticBanner
        title={title}
        bannerImg={{
          fit: 'cover',
          src: banner,
          alt: title
        }}
      />

      <div className="page page--news-detail">
        <div className="container">
          <article className="article">
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: body }}
            />
          </article>
        </div>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/containers/NewsArticle/render.tsx